import { connect } from 'react-redux';
import { negotiationCountState } from '../../../redux/reducers/NegotiationCountReducer';
import { AppState } from '../../../redux/modules/store';
import { getAnnotationMasterListFromMasterInfo, MasterInfoState } from '../../../redux/reducers/MasterInfoReducer';
import { isAgencyModule, isCrewModule } from '../../../utils/Env';
import { AnnotationTooltipProps } from '../../../component/molecules/AnnotationTooltip';
import NegotiationCountList from '../../../component/organisms/NegotiationCountList';
import ANNOTATION_ID from '../../../redux/reducers/MasterInfoReducer/definitions/AnnotationId';

export interface NegotiationHandler {
  negotiationCount: negotiationCountState;
}

const mapStateToProps = (appState: AppState) => {
  return {
    negotiationCount: {
      countNum: {
        negotiationTotal: appState.negotiationCount.countNum.negotiationTotal,
        customerTotal: appState.negotiationCount.countNum.customerTotal,
        noneNegotiation: appState.negotiationCount.countNum.noneNegotiation,
        noneProduct: appState.negotiationCount.countNum.noneProduct,
        doing: appState.negotiationCount.countNum.doing,
        pending: appState.negotiationCount.countNum.pending,
        done: appState.negotiationCount.countNum.done,
        customerDoing: appState.negotiationCount.countNum.customerDoing,
        customerPending: appState.negotiationCount.countNum.customerPending,
        customerDone: appState.negotiationCount.countNum.customerDone,
      },
    },
    tooltipInfo: {
      negotiation: getTooltipInfo(appState.masterInfo, 'negotiation'),
      report: getTooltipInfo(appState.masterInfo, 'report'),
    },
  };
};

const getTooltipInfo = (masterInfo: MasterInfoState, type: string) => {
  let annotationId = null;
  switch (type) {
    case 'negotiation':
      annotationId = isCrewModule() ? ANNOTATION_ID.ANTT_I_7 : isAgencyModule() ? ANNOTATION_ID.ANTT_I_12 : ANNOTATION_ID.ANTT_I_17;
      break;
    case 'report':
      annotationId = isCrewModule() ? ANNOTATION_ID.ANTT_I_8 : isAgencyModule() ? ANNOTATION_ID.ANTT_I_13 : ANNOTATION_ID.ANTT_I_18;
      break;
  }

  if (annotationId) {
    const tooltipInfo = getAnnotationMasterListFromMasterInfo(masterInfo, annotationId);
    return {
      content: tooltipInfo.annotationText,
      url: tooltipInfo.linkUrl,
      label: tooltipInfo.linkText,
    };
  }
  return {} as AnnotationTooltipProps;
};

export default connect(mapStateToProps)(NegotiationCountList);
